module.exports = __webpack_public_path__ + "img/pagi.36caad06.png";